var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-auto" },
    [
      _c("label", { staticClass: "col-form-label mr-2" }, [
        _vm._v(" " + _vm._s(_vm.label) + " ")
      ]),
      _c("b-form-select", {
        staticClass: "custom-select custom-select-sm",
        staticStyle: { width: "max-content" },
        attrs: { options: _vm.opt, value: _vm.value },
        on: { change: _vm.changeItem }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }